import { style } from '@vanilla-extract/css';

export const imageBlockContainer = style({
  paddingLeft: 'var(--wt-padding-left-value-w-fallback)',
  paddingRight: 'var(--wt-padding-right-value-w-fallback)',
});

export const imagePaddingContainer = style({
  paddingBottom: 'var(--wt-image-padding-bottom, 20px)',
  paddingTop: 'var(--wt-image-padding-top, 20px)',
  paddingLeft: 'var(--wt-image-padding-left, 20px)',
  paddingRight: 'var(--wt-image-padding-right, 20px)',
});

export const image = style({
  width: '100%',
});

export const imageAlignLeft = style({
  margin: '0 auto 0 0',
});

export const imageAlignRight = style({
  margin: '0 0 0 auto',
});

export const imageAlignCenter = style({
  margin: '0 auto 0 auto',
});
